import { Helmet } from "react-helmet-async";

const SITE_ROOT = process.env.REACT_APP_SITE_URL || "https://lefildumidi.les-arteurs.org";
const DEFAULT_IMAGE = "https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/fwibbexq_do%20you%20have%20time%20to%20dream.jpg";

/**
 * Per-page SEO / Open Graph / Twitter Card overrides.
 * Falls back to values in public/index.html when props are omitted.
 *
 * Props
 * - title: full page title (auto-suffixed with · Le Fil du Midi)
 * - description: short summary (max ~160 chars)
 * - image: absolute URL to the OG image (must be public-facing)
 * - path: pathname for canonical + og:url (defaults to current location)
 */
export default function PageSEO({ title, description, image, path, imageAlt, type = "website" }) {
  const fullTitle = title
    ? `${title} · Le Fil du Midi`
    : "Le Fil du Midi · Canal'Art 2026 · 30 ans UNESCO";
  const desc = description ||
    "Le plus grand parcours artistique à ciel ouvert du monde : 750 km d'art le long du Canal des 2 mers, célébrant les 30 ans UNESCO du Canal du Midi.";
  const img = image || DEFAULT_IMAGE;
  const pathname = path || (typeof window !== "undefined" ? window.location.pathname : "/");
  const url = `${SITE_ROOT}${pathname}`;
  const alt = imageAlt || fullTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:image:secure_url" content={img} />
      <meta property="og:image:alt" content={alt} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:image:alt" content={alt} />
    </Helmet>
  );
}
